import React, { Component } from 'react'
import CoverFlow, { EFFECT_TYPES } from '../../CoverFlow'
import logo from '../../../assets/rhomberg-logo.svg'
import AnimatedLogo from '../../Libs/AnimatedLogo'
import { Context } from '../../Context'

export default class References extends Component {
    static contextType = Context

    constructor(props) {
        super(props)
        this.state = {}
    }
    render() {
        return (
            <div className="main">
                <AnimatedLogo image={logo} />
                <h1 className="page-title p-3">Bauen im Bestand</h1>
                <div className="container-fluid pos-relative">
                    <div className="slider-height">
                        <CoverFlow
                            effect={EFFECT_TYPES.COVERFLOW}
                            data={this.context.state.inStockProjects}
                            onItemClick={(item, index) => {
                                this.props.history.push('/bauen-im-bestand/referenzen/' + index)
                            }}
                        />
                    </div>
                </div>
            </div>
        )
    }
}
